<template>
  <div>
    <Modal v-model="visible" width="500px" title="发起签署合同" :footer-hide="true" :mask-closable="false" class="my-modal top" :closable="!loading">
      <div v-if="!loading">
        <Form ref="form" :model="formData" :label-width="100" class="page-form" v-if="visible">
          <FormItem prop="beginDate" label="合同开始时间" :rules="$units.formRule.required('请选择')" class="full">
            <DatePicker
              type="date"
              :transfer="true"
              :value="formData.beginDate"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              @on-change="$set(formData, 'beginDate', $event)"
            ></DatePicker>
          </FormItem>
          <FormItem prop="endDate" label="合同结束时间" :rules="$units.formRule.required('请选择')" class="full">
            <DatePicker
              type="date"
              :transfer="true"
              :value="formData.endDate"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              @on-change="$set(formData, 'endDate', $event)"
            ></DatePicker>
          </FormItem>
        </Form>
        <div class="ivu-modal-footer">
          <Button type="text" @click="visible = false">取消</Button>
          <Button type="primary" @click="submit">下一步</Button>
        </div>
      </div>

      <Col class="demo-spin-col" span="24" v-else>
        <Spin fix>
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div class="text">文件正在生成中，请耐心等待...</div>
        </Spin>
      </Col>
    </Modal>
    <!-- 预览合同 -->
    <contract-preview-modal ref="contractPreviewModal" @success="$emit('success')" @cancel="visible = true"></contract-preview-modal>
  </div>
</template>

<script>
import contractPreviewModal from './contractPreviewModal';
export default {
  components: { contractPreviewModal },
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {}
    };
  },
  created() {},
  methods: {
    open(data = {}) {
      if (!this.$units.pointAction('org_2125_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.formData = JSON.parse(JSON.stringify(data));
      this.visible = true;
      this.loading = false;
    },
    submit() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        if (this.formData.beginDate > this.formData.endDate) {
          this.$notice.error('合同结束时间必须大于合同开始时间');
          return;
        }
        this.nextStep();
      });
    },

    nextStep() {
      this.loading = true;
      this.$http({
        url: '/buz/entryUserAuth/createSignFile',
        type: 'POST',
        forced: true,
        data: {
          registerId: this.formData.id,
          beginDate: this.formData.beginDate,
          endDate: this.formData.endDate,
          auditStatus: this.formData.auditStatus
        },
        apiPermissionCode: 'org_2125_4'
      }).then(res => {
        if (res.httpCode == 500002) {
          this.$Modal.error({
            title: '提示',
            width: 700,
            closable: true,
            content: `<p style='white-space: pre-wrap;'>${JSON.parse(res.msg).msg || res.msg}<p>`
          });
          this.loading = false;
        } else if (res.httpCode != 5002 && res.httpCode != 1) {
          this.$Modal.error({
            title: '提示',
            width: 700,
            closable: true,
            content: `<p style='white-space: pre-wrap;'>${res.msg}<p>`
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.$refs.contractPreviewModal.open(this.formData, res.data);
        }
        this.visible = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 50px;
  margin-top: 50px;
  .text {
    color: #236dff;
  }
}
</style>
